export default {
domainUrl:'https://liwzlab.cn/single/v1',//'http://202.116.105.13:8086/single/v1', //,//'http://liwzlab.ifr.fidt.top:61010/single/v1',
  
  getVisitRNA: '/visitRNA/get',
  getData: '/type_data',
  downloadCsv: '/csv',
  readCsv: '/readCSV',
  getMetadata: '/metadata',
  metadataSearch: '/metadata/search',
  getType: '/metadata/getType',
  getExplore: '/explore/getType',

  getDataset: '/metadata/getDataByType',
  getJob: '/metadata/getJob',
  runJob: '/metadata/run',
  getTableType: '/type_table',
  exploreGetDataBy: '/explore/getDataBy',
  exploreGetSampleBy: '/explore/getSampleBy'
}
